const LinkedIn = (props: { fill: string }) => {
	return (
		<>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.1857 21C20.1876 21 21 20.195 21 19.2007V4.79928C21 3.806 20.1886 3 19.1857 3H4.81434C3.81242 3 3 3.806 3 4.79928V19.2007C3 20.194 3.81138 21 4.81434 21H19.1857ZM8.85554 7.40145C8.85554 8.0626 8.36139 8.59855 7.54896 8.59855C6.7847 8.59855 6.29054 8.0626 6.29054 7.40145C6.29054 6.7403 6.8004 6.20435 7.58142 6.20435C8.36243 6.20435 8.83984 6.72375 8.85554 7.40145ZM6.35441 17.2421V9.54216H8.77597V17.2421H6.35441ZM10.2249 11.9984C10.2249 11.0383 10.1935 10.2354 10.1611 9.54216H12.2644L12.3764 10.613H12.4246C12.7428 10.1092 13.5238 9.36937 14.8304 9.36937C16.4239 9.36937 17.6184 10.4247 17.6184 12.6917V17.2421H15.1968V12.9752C15.1968 11.9829 14.8461 11.3063 13.9698 11.3063C13.3008 11.3063 12.903 11.7625 12.7271 12.2033C12.6633 12.3606 12.6475 12.581 12.6475 12.8013V17.2411H10.226V11.9974L10.2249 11.9984Z"
				fill={props.fill}
			/>
		</>
	);
};

export default LinkedIn;
